import React, { memo, useState, useContext } from 'react'
import { SPContext } from '../../SPContext'
import PageLoading from '../helpers/PageLoading'
import { Row, Col, Button, Collapse, UncontrolledTooltip } from 'reactstrap'
import moment from 'moment'
import CommentInput from './CommentInput'
import ConfirmDialogModal from '../confirm_dialog/ConfirmDialogModal'
import Axios from 'axios'

const Comment = memo(
  ({
    ev_comment,
    ev_comments,
    setComments,
    event,
    users,
    user_id,
    token,
    isAdmin,
    uri,
  }) => {
    const getUser = user_id => {
      const user = (users &&
        users.find(u => parseInt(u.id, 10) === parseInt(user_id, 10))) || {
        fist_name: '',
        last_name: '',
      }
      return (
        (user && {
          ...user,
          label: user.first_name + ' ' + user.last_name,
        }) ||
        {}
      )
    }

    if (!event) return <PageLoading />

    const [replies_open, setRepliesOpen] = useState(false)
    const [reply_open, setReplyOpen] = useState(false)

    const [open_confirm_dialog, setOpenConfirmDialog] = useState(false)
    const [confirm_dialog_title, setConfirmDialogTitle] = useState(false)
    const [confirm_dialog_content, setConfirmDialogContent] = useState(false)
    const [confirm_dialog_comment_id, setConfirmDialogCommentId] = useState(0)

    const confirmCommentDelete = (e, confirmed) => {
      if (confirmed) {
        removeCommentPost()
      }
      setOpenConfirmDialog(false)
    }

    const removeComment = (e, event_comment_id) => {
      setConfirmDialogTitle('Remove comment')
      setConfirmDialogContent(() => (
        <div>
          <span>Are you sure you want to remove this comment?</span>
          <p />
          <div className='mt-1 sp-comment-description'>
            {ev_comment.event_comment_text.split('\n').map((line, ix) => (
              <span key={`event_comment_dialog_description_lines_${ix}`}>
                {line}
              </span>
            ))}
          </div>
        </div>
      ))
      setConfirmDialogCommentId(event_comment_id)
      setOpenConfirmDialog(true)
    }

    const removeCommentPost = () => {
      const data = new FormData()
      data.append('event_comment_id', confirm_dialog_comment_id)
      data.append(
        'event_comment_FK_event_id',
        ev_comment.event_comment_FK_event_id,
      )
      data.append('event_comment_FK_event_comment_status_id', 2)
      data.append('token', token)

      Axios.post(`${uri}Event_Comment/save`, data)
        .then(response => {
          setComments(response.data.data)
        })
        .catch(err => {
          console.log(err)
        })
    }

    const handleReply = e => {
      if (reply_open && reply_open && e.target.textContent === 'Reply') {
        return false
      }
      setReplyOpen(!reply_open)
    }

    const handleViewReplies = () => {
      setRepliesOpen(!replies_open)
    }

    const CommentReplies = ({ children }, props) => {
      // children.sort((a, b) => {
      //   const d_a = new Date(a.event_comment_created_at)
      //   const d_b = new Date(b.event_comment_created_at)
      //   const _return = d_a < d_b ? 1 : d_b < d_a ? -1 : 0
      //   return _return
      // })

      return (
        <>
          <Row className='sp-comment-replies-toggle'>
            <Col>
              <span onClick={handleViewReplies}>
                {(!replies_open &&
                  'View ' +
                    children.length +
                    (children.length > 1 ? ' replies ' : ' reply ')) ||
                  'Hide replies '}
                <i
                  className={
                    'fas ' + (replies_open ? 'fa-angle-up' : 'fa-angle-down')
                  }
                />
              </span>
            </Col>
          </Row>

          <Collapse isOpen={replies_open}>
            {children.map(child_comment => {
              return (
                <Comment
                  event={event}
                  ev_comments={ev_comments}
                  setComments={setComments}
                  ev_comment={child_comment}
                  uri={uri}
                  isAdmin={isAdmin}
                  users={users}
                  user_id={user_id}
                  token={token}
                  key={`event_comment_${child_comment.event_comment_id}`}
                />
              )
            })}
          </Collapse>
        </>
      )
    }

    return (
      <>
        <ConfirmDialogModal
          isOpen={open_confirm_dialog}
          title={confirm_dialog_title}
          content={confirm_dialog_content}
          fnAction={confirmCommentDelete}
          isProcessing={false}
        />

        <Row className='sp-comment-item'>
          <Col md='2' xs='2' className='sp-comment-user-image'>
            <img
              width={50}
              height={50}
              src={
                '/timthumb.php?width=50&height=50&src=https://socialfiles.blob.core.windows.net/staff/' +
                ev_comment.event_comment_FK_created_by_user_id +
                '.jpg'
              }
              alt="I'm going"
            />
          </Col>
          <Col
            md='10'
            xs='10'
            className='sp-comment-item sp-comment-item-header'
          >
            {(isAdmin &&
              ev_comment.event_comment_FK_event_comment_status_id !== '2' && (
                <>
                  <i
                    className='fas fa-minus-circle sp-comment-remove-comment'
                    id={`delete-comment-${ev_comment.event_comment_id}`}
                    onClick={e => removeComment(e, ev_comment.event_comment_id)}
                  />

                  <UncontrolledTooltip
                    placement='top'
                    target={`delete-comment-${ev_comment.event_comment_id}`}
                  >
                    Remove comment
                  </UncontrolledTooltip>
                </>
              )) ||
              null}
            <strong>
              {getUser(ev_comment.event_comment_FK_created_by_user_id).label}
            </strong>
            {'  '}
            <span>
              {moment(
                ev_comment.event_comment_created_at,
                'YYYYMMDD hh:mm',
              ).fromNow()}
            </span>
          </Col>
        </Row>

        <Row>
          <Col
            md={{ size: '10', offset: '2' }}
            xs={{ size: '10', offset: '2' }}
            className='sp-comment-description sp-comment-description-label'
          >
            {ev_comment.event_comment_text.split('\n').map((line, ix) => (
              <span
                key={`event_comment_description_lines_${ix}`}
                className={
                  (ev_comment.event_comment_FK_event_comment_status_id ===
                    '2' &&
                    'sp-comment-deleted-by-admin') ||
                  ''
                }
              >
                {line}
              </span>
            ))}
          </Col>
        </Row>

        <Row>
          <Col
            md={{ size: '10', offset: '2' }}
            xs={{ size: '10', offset: '2' }}
            className='sp-comment-reply-button'
          >
            <Button color='info' size='sm' onClick={e => handleReply(e)}>
              Reply
            </Button>
          </Col>
        </Row>

        <Collapse isOpen={reply_open}>
          <Row>
            <Col
              md={{ size: '10', offset: '2' }}
              xs={{ size: '10', offset: '2' }}
            >
              <CommentInput
                key={`comment_input_${ev_comment.event_comment_id}`}
                event={event}
                ev_comment={ev_comment}
                ev_comments={ev_comments}
                setComments={setComments}
                users={users}
                user_id={user_id}
                token={token}
                rows_size={1}
                fnCancel={handleReply}
              />
            </Col>
          </Row>
        </Collapse>

        {(ev_comment.event_comment_children &&
          ev_comment.event_comment_children.length > 0 && (
            <Row className='sp-comment-replies'>
              <Col xs={{ size: '10', offset: '2' }}>
                <CommentReplies children={ev_comment.event_comment_children} />
              </Col>
            </Row>
          )) ||
          null}
        {/* <hr /> */}
      </>
    )
  },
)

const CommentContainer = props => {
  const { uri, isAdmin, users, user_id, token } = useContext(SPContext)
  return (
    <Comment
      uri={uri}
      isAdmin={isAdmin}
      users={users}
      user_id={user_id}
      token={token}
      {...props}
    />
  )
}

export default CommentContainer
